<template>
  <div class="text-xs md:text-header-window">
    <div class="flex w-full text-xxs md:text-xs  items-center justify-center md:justify-start ml-px flex-wrap gap-4 md:min-w-80 md:ml-1">
      <div class="flex flex-col items-center flex-wrap">
        <img src="/img/icons/projects/tools/html.png" :alt="$t('common.icon') + ' Wordpress'" class="w-9 h-9" />
        <p class="font-bold mt-px">HTML</p>
      </div>
      <div class="flex flex-col items-center flex-wrap">
        <img src="/img/icons/projects/tools/css.png" :alt="$t('common.icon') + ' Visual Studio Code'" class="w-9 h-9" />
        <p class="font-bold mt-px">CSS</p>
      </div>
       <div class="flex flex-col items-center flex-wrap">
        <img src="/img/icons/projects/tools/javascript.svg" :alt="$t('common.icon') + ' Visual Studio Code'" class="w-9 h-9" />
        <p class="font-bold mt-px">JavaScript</p>
      </div>
      <div class="flex flex-col items-center flex-wrap">
        <img src="/img/icons/projects/tools/vuejs.svg" :alt="$t('common.icon') + ' Visual Studio Code'" class="w-9 h-9" />
        <p class="font-bold mt-px">VueJS</p>
      </div>
      <div class="flex flex-col items-center flex-wrap">
        <img src="/img/icons/projects/tools/vscode.svg" :alt="$t('common.icon') + ' Visual Studio Code'" class="w-9 h-9" />
        <p class="font-bold mt-px">VsCode</p>
      </div>
    </div>
    <h3 class="mt-5 mb-2">{{ $t('common.context') }}</h3>
    <p class="mb-2">{{ $t('project.emc2.contextFirstParagraph') }}</p>
    <p class="mb-2">{{ $t('project.emc2.contextSecondParagraph') }}</p>
    <p class="mb-2">{{ $t('project.emc2.contextFourthParagraph') }}</p>
  </div>
</template>

<script setup>
let ProjectName = 'Emc2';
</script>
